import { pushToDataLayer } from '@/utils/analytics/analytics';

export function gaBuilderFacets(success = false, count = 0, price = 0) {
    if(success) {
        pushToDataLayer({
            event_name: 'generate_facets_success',
            interaction_type: 'generate_facets',
            dataset_count: count,
            dataset_price: price
        });
    } else {
        pushToDataLayer({
            event_name: 'generate_facets_error',
            interaction_type: 'generate_facets'
        });
    }
}

export function gaBuilderResultsCount(success = false, count = 0, price = 0) {
    if(success) {
        pushToDataLayer({
            event_name: 'generate_results_count_success',
            interaction_type: 'generate_resultscount',
            dataset_count: count,
            dataset_price: price
        });
    } else {
        pushToDataLayer({
            event_name: 'generate_results_count_error',
            interaction_type: 'generate_resultscount'
        });
    }
}

export function gaBuilderFormSubmit(formSlug, success = false, count = 0, price = 0) {
    switch (formSlug) {
        case 'checkout':
            if(success) {
                pushToDataLayer({
                    event_name: 'form_submit_success',
                    form_id: 'order_checkout_form',
                    interaction_type: 'form_submit',
                    dataset_count: count,
                    dataset_price: price
                });
            } else {
                pushToDataLayer({
                    event_name: 'form_submit_error',
                    form_id: 'order_checkout_form',
                    interaction_type: 'form_submit',
                });
            }
            break;
        case 'consult':
            if(success) {
                pushToDataLayer({
                    event_name: 'form_submit_success',
                    form_id: 'order_consult_form',
                    interaction_type: 'form_submit',
                    dataset_count: count,
                    dataset_price: price
                });
            } else {
                pushToDataLayer({
                    event_name: 'form_submit_error',
                    form_id: 'order_consult_form',
                    interaction_type: 'form_submit',
                });
            }
            break;
        case 'contact':
            if(success) {
                pushToDataLayer({
                    event_name: 'form_submit_success',
                    form_id: 'contact_form_popup',
                    interaction_type: 'form_submit',
                });
            } else {
                pushToDataLayer({
                    event_name: 'form_submit_error',
                    form_id: 'contact_form_popup',
                    interaction_type: 'form_submit',
                });
            }
            break;
        default: break;
    }
}

export function gaBuilderPayment(success = false, count = 0, price = 0, orderId = null, query = null) {
    if(success) {
        pushToDataLayer({
            event_name: 'payment_success',
            interaction_type: 'mollie_payment',
            dataset_count: count,
            dataset_price: price,
            order_id: orderId,
            dataset_query: query
        });
    } else {
        pushToDataLayer({
            event_name: 'payment_failed',
            interaction_type: 'mollie_payment',
            dataset_count: count,
            dataset_price: price
        });
    }
}

